<div class="modal-header container-md" id="modal-header">
    <div class="col-4"></div>
    <div class="col-4">
      <img id="modal-memorabid-logo" src="/assets/img/memorabid-logo-white.svg" alt="MEMORABID">
    </div>
    <div class="col-3"></div>
    <div class="col-1">
      <button id="closeButton" type="button" class="close" aria-label="Close" (click)="activeModal.close(false)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
</div>
<div class="modal-body mx-3">
    <div>
        <h4 class="text-uppercase">{{'IDS_CONFIRM_RESERVE_RAISE' | translate}}</h4>
    </div>
    <div class="mt-3">
        <label>
            <span class="me-1">{{'IDS_YOU_SURE_RESERVE_PRICE' | translate}}</span>
            <span class="price">{{ reservePrice }} €</span>
        </label>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <button class="btn-gold text-uppercase fw-bold px-3" type="button" (click)="activeModal.close(true)">{{'IDS_CONFIRM' | translate}}</button>
    </div>
    <div class="d-flex justify-content-center my-3">
        <button class="admin-new text-uppercase fw-bold px-3" type="button" (click)="activeModal.close(false)">{{'IDS_BTN_ABORT' | translate}}</button>
    </div>
</div>
